// extracted by mini-css-extract-plugin
export default {"container":"lib-component-mappings-sky-parallax-components-Checkout-Simplified-Total-styles-module__container--qmfOh"};